import React from "react";

const AdminOrderDetails = ({ order }) => {
  if (!order) return null;

  const {
    orderNumber,
    createdAt,
    paymentMethod,
    sameDayFee = 0,
    hamperDiscount = 0,
    promoCode = null,
    totalAmount = 0,
    taxAmount = 0,
    hamperType = "",
    deliveryAddress,
    deliveryNote,
    giftMessage,
    grouped = {},
    hamperItems = [],
    selectedFlowers = [],
    selectedAccessories = [],
    selectedVips = [],
  } = order;

  const items = {
    hamperItems: grouped.hamperItems || hamperItems,
    flowers: grouped.selectedFlowers || selectedFlowers,
    accessories: grouped.selectedAccessories || selectedAccessories,
    vips: grouped.selectedVips || selectedVips,
  };

  const orderDate = createdAt
    ? new Date(createdAt).toLocaleDateString()
    : "N/A";

  return (
    <div className="max-w-3xl mx-auto bg-white p-6 rounded-xl shadow-md">
      {/* Header */}
      <div className="flex justify-between items-start mb-6">
        <img
          src="/images/logos/Exudee-logo.svg"
          alt="Exudee Hampers"
          className="h-10"
        />
        <div className="text-right">
          <h2 className="text-xl font-bold text-gray-800">
            Order #{orderNumber}
          </h2>
          <p className="text-sm text-gray-600">{orderDate}</p>
          <p className="text-sm text-gray-600">
            Payment: {paymentMethod?.toUpperCase() || "N/A"}
          </p>
        </div>
      </div>

      <hr className="my-4" />

      {/* Hamper Items */}
      {items.hamperItems.length > 0 && (
        <>
          <h4 className="font-semibold mb-2">
            Hamper Package: {hamperType}
          </h4>
          {items.hamperItems.map((item, i) => (
            <div key={i} className="flex justify-between text-sm mb-1">
              <span>{item.name} × {item.quantity || 1}</span>
              <span>
                ${(item.price * (item.quantity || 1)).toFixed(2)}
              </span>
            </div>
          ))}
          <hr className="my-4" />
        </>
      )}

      {/* Flowers */}
      {items.flowers.length > 0 && (
        <>
          <h4 className="font-semibold mb-2">Flowers</h4>
          {items.flowers.map((f, i) => (
            <div key={i} className="flex justify-between text-sm mb-1">
              <span>{f.name} × {f.quantity || 1}</span>
              <span>${(f.price * (f.quantity || 1)).toFixed(2)}</span>
            </div>
          ))}
          <hr className="my-4" />
        </>
      )}

      {/* Accessories */}
      {items.accessories.length > 0 && (
        <>
          <h4 className="font-semibold mb-2">Accessories</h4>
          {items.accessories.map((a, i) => (
            <div key={i} className="flex justify-between text-sm mb-1">
              <span>{a.name} × {a.quantity || 1}</span>
              <span>${(a.price * (a.quantity || 1)).toFixed(2)}</span>
            </div>
          ))}
          <hr className="my-4" />
        </>
      )}

      {/* VIP */}
      {items.vips.length > 0 && (
        <>
          <h4 className="font-semibold mb-2">VIP Items</h4>
          {items.vips.map((v, i) => (
            <div key={i} className="flex justify-between text-sm mb-1">
              <span>{v.name} × {v.quantity || 1}</span>
              <span>${(v.price * (v.quantity || 1)).toFixed(2)}</span>
            </div>
          ))}
          <hr className="my-4" />
        </>
      )}

      {/* Delivery Info */}
      {(deliveryAddress || deliveryNote || giftMessage) && (
        <>
          <div className="bg-gray-50 p-4 rounded-lg text-sm">
            {deliveryAddress && (
              <p><strong>Delivery Address:</strong> {deliveryAddress}</p>
            )}
            {deliveryNote && (
              <p><strong>Instruction:</strong> {deliveryNote}</p>
            )}
            {giftMessage && (
              <p><strong>Gift Message:</strong> {giftMessage}</p>
            )}
          </div>
          <hr className="my-4" />
        </>
      )}

      {/* Totals */}
      {sameDayFee > 0 && (
        <div className="flex justify-between text-sm">
          <span>Same-Day Fee</span>
          <span>${sameDayFee.toFixed(2)}</span>
        </div>
      )}

      {hamperDiscount > 0 && (
        <div className="flex justify-between text-sm text-green-700">
          <span>Hamper Discount</span>
          <span>- ${hamperDiscount.toFixed(2)}</span>
        </div>
      )}

      {promoCode && (
        <div className="flex justify-between text-sm text-green-700">
          <span>Promo ({promoCode.code})</span>
          <span>- ${promoCode.discountValue.toFixed(2)}</span>
        </div>
      )}

      <div className="flex justify-between text-sm mt-2">
        <span>Tax</span>
        <span>${taxAmount.toFixed(2)}</span>
      </div>

      <div className="flex justify-between text-lg font-bold mt-2">
        <span>Total Paid</span>
        <span>${totalAmount.toFixed(2)}</span>
      </div>
    </div>
  );
};

export default AdminOrderDetails;
